import React, { Component } from 'react';
import { Popover, Table, Tag } from 'antd';
import moment from 'moment';

import util from '@util/index';

class TableBase2 extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getSum = data => {
    return data.reduce((prev, current) => {
      return prev + current.price;
    }, 0);
  };

  columns = () => {
    const typeFont = ['押金', '工位收入', '地址收入'];
    const renderMoney = (key, title) => {
      return {
        title,
        dataIndex: key,
        width: 150,
        render: text => <span>{text ? util.numberFormat(text) : 0}</span>,
      };
    };

    return [
      {
        title: '账单编号',
        dataIndex: 'payableNo',
        width: 200,
        render: (text, record) => {
          const content = (
            <div>
              <p>时间:{moment(record.sleepDate).format('YYYY-MM-DD')}</p>
              <p>操作人员:{record.sleepUser}</p>
              <p>原因:{record.sleepRemark}</p>
            </div>
          );
          return (
            <div>
              {record.sleepStatus === 1 ? (
                <Popover content={content}>
                  <Tag color="gray">休眠</Tag>
                </Popover>
              ) : (
                ''
              )}
              {text}
            </div>
          );
        },
      },
      {
        title: '企业名称',
        dataIndex: 'custom',
        width: 150,
      },
      {
        title: '对应租期',
        dataIndex: 'beginDate',
        width: 250,
        render: (text, record) =>
          record.beginDate && record.endDate ? (
            <span>
              {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
              {moment.unix(record.endDate / 1000).format('YYYY-MM-DD')}
            </span>
          ) : null,
      },
      {
        title: '收入类型',
        dataIndex: 'type',
        width: 100,
        render: text => <span>{typeFont[text]}</span>,
      },
      renderMoney('price', '待退款'),
      renderMoney('confirm', '已退款'),
      renderMoney('shouldMatchTheFlow', '应匹配流水'),
      renderMoney('actualMatchTheFlow', '实匹配流水'),
      {
        title: '款项状态',
        dataIndex: 'payStatus',
        width: 100,
        render: (text, record) => {
          let statusFont = '';
          if (!record.confirm) {
            statusFont = '没有匹配';
          } else if (record.confirm >= record.price) {
            statusFont = '完成匹配';
          } else {
            statusFont = '部分匹配';
          }
          return <span>{statusFont}</span>;
        },
      },
      {
        title: '终止生效日期',
        dataIndex: 'termDate',
        width: 150,
        render: text => <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : null}</span>,
      },
    ];
  };

  render() {
    const { detail } = this.props;
    const data = [
      {
        ...detail,
      },
    ];
    return (
      <Table
        columns={this.columns()}
        dataSource={data}
        pagination={false}
        rowKey="index"
        scroll={{ x: 1500 }}
      />
    );
  }
}

export default TableBase2;



// WEBPACK FOOTER //
// ./src/components/incubator/bill/TableBase2.js